import axios from '../base/axios';
import API_KEY from './key';

const GET_LATEST = 'flixfrenzy/redux/GET_LATEST';

// eslint-disable-next-line default-param-last
const latestReducer = (state = [], action) => {
  switch (action.type) {
    case GET_LATEST:
      return action.payload;
    default:
      return state;
  }
};

export const getLatest = () => (dispatch) => {
  axios.get(`movie/latest?api_key=${API_KEY}&language=en-US`).then((res) => {
    dispatch({
      type: GET_LATEST,
      payload: res.data,
    });
  });
};

export default latestReducer;
